import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/core/services/data.service';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { ManagedServicesConfigService } from '../../services/managed-services-config.service';
import { ManagedServicesRepository } from '../../services/managed-services-repository.service';

@Component({
  selector: 'msp-configuration',
  templateUrl: './msp-configuration.component.html',
  styleUrls: ['./msp-configuration.component.scss'],
  standalone: false,
})
export class MspConfigurationComponent implements OnInit {
  /** Load configuration flag to show/hide the configuration page */
  loadConfiguration = false;

  canAdd = false;
  canEdit = false;
  canDelete = false;

  /** Sidenav collapsed state */
  sidenavCollapsed = false;

  constructor(
    private userService: UserDataService,
    private permissionsService: PermissionsService,
    private router: Router,
    private dataService: DataService,
    public managedServicesConfigService: ManagedServicesConfigService,
    public managedServicesRepository: ManagedServicesRepository,
  ) {
    // Subscribe to the data service to get the sidenav collapsed state
    this.dataService.isCollapsedSidenav$.subscribe((data) => {
      this.sidenavCollapsed = data;
    });
    // Subscribe to the user service to check if the user has MSP configuration access
    this.userService.user$.subscribe(() => {
      if (!this.permissionsService.hasPermission('managed-services', 'Settings', 'view')) {
        this.router.navigateByUrl('/secured/managed-services');
      } else {
        this.loadConfiguration = true;
        ({
          canAdd: this.canAdd,
          canEdit: this.canEdit,
          canDelete: this.canDelete,
        } = this.permissionsService.getWritePermissions('managed-services', 'Settings', true));
      }
    });
  }

  ngOnInit(): void {
    // Fetch the noc/soc config
    this.managedServicesConfigService.fetchCompanyEscalationSettings();
    // Fetch the company escalation order
    this.managedServicesConfigService.fetchCompanyEscalationOrder();
    // Fetch the allowed users config
    this.managedServicesConfigService.fetchAllowedUsersConfig();
  }
}
